import { RouteRecordRaw } from 'vue-router';
import { useEnvsStore } from 'stores/envs';

export default function (/* { store }: { store: Store<never> } */) {
  const routes: RouteRecordRaw[] = [
    {
      path: '/',
      component: () => import('layouts/RootLayout.vue'),
      children: [
        {
          path: '',
          component: () => import('layouts/MainLayout.vue'),
          children: [
            { path: '', component: () => import('pages/Index.vue') },
            {
              path: 'about',
              component: () => import('src/pages/AboutPage.vue'),
            },
            {
              path: 'contact',
              component: () => import('src/pages/ContactPage.vue'),
            },
            {
              name: 'contact-details',
              path: 'contact-details/:slug',
              component: () => import('src/pages/ContactDetailsPage.vue'),
            },
            {
              path: 'cookies-policy',
              name: 'cookies-policy',
              component: () => import('src/pages/CookiesPolicyPage.vue'),
            },
            {
              path: 'privacy-policy',
              name: 'privacy-policy',
              component: () => import('src/pages/PrivacyPolicyPage.vue'),
            },
            {
              path: 'how-to',
              name: 'how-to',
              component: () => import('pages/HowToPage.vue'),
              meta: { requiresAuth: true },
            },
            {
              path: 'weekly-availability/:type',
              name: 'weekly-availability',
              component: () => import('src/pages/WeeklyAvailabilityPage.vue'),
            },
            {
              path: 'incident-report',
              name: 'incident-report',
              component: () =>
                import('pages/Incident-report/IncidentReportPage.vue'),
            },
            {
              path: 'terms-and-conditions',
              name: 'terms-and-conditions',
              component: () => import('src/pages/TermsAndConditionsPage.vue'),
            },
            {
              name: 'services',
              path: 'services',
              component: () =>
                import('src/pages/service/AppointmentCategoryView.vue'),
            },
            {
              path: 'services/:category_id',
              name: 'service-category',
              component: () => import('src/pages/service/Index.vue'),
            },
            {
              path: 'services/:slug/detail',
              name: 'service-detail',
              component: () => import('src/pages/service/Detail.vue'),
            },
            {
              path: 'services/:slug/availability',
              name: 'service/availability',
              component: () => import('src/pages/service/Availability.vue'),
            },
            {
              path: 'news',
              name: 'news',
              component: () => import('src/pages/news/NewsFeedPage.vue'),
            },
            {
              path: 'news/:id',
              name: 'news-detail',
              component: () => import('src/pages/news/NewsDetailPage.vue'),
            },
            {
              name: 'update-details',
              path: 'update-details',
              component: () => import('src/pages/user/UpdateDetailsPage.vue'),
            },
            {
              name: 'user-profile',
              path: 'user/profile',
              component: () => import('src/pages/user/UserProfile.vue'),
              meta: { requiresAuth: true },
            },
            {
              path: 'user/appointments',
              name: 'user/appointments',
              component: () =>
                import('pages/user/appointment/AppointmentsList.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'appointments-details-forms',
              path: ':type/record-details/',
              component: () =>
                import(
                  'pages/user/appointment/appointment-view/AppointmentView.vue'
                ),
            },
            {
              name: 'appointment-forms',
              path: ':type/forms/for-appointment/:id',
              component: () =>
                import('pages/user/appointment/ForAppointment.vue'),
            },
            {
              name: 'in-progress-forms',
              path: ':type/forms/in-progress/:id',
              component: () =>
                import('pages/user/in-progress/InProgressView.vue'),
            },
            {
              name: 'completed-forms',
              path: ':type/forms/completed/:id',
              component: () => import('pages/user/completed/CompletedView.vue'),
            },
            {
              name: 'appointment-outcomes',
              path: ':type/appointments/:appointment_id/outcomes/:outcome_id',
              component: () =>
                import('pages/user/appointment/AppointmentOutcomesView.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'clinician-forms',
              path: ':type/forms/clinician/:id',
              component: () =>
                import('pages/user/appointment/ClinicianView.vue'),
              meta: { requiresAuth: true },
            },
            {
              path: '/login',
              component: () => import('src/pages/LoginPage.vue'),
            },
            {
              name: 'clinic/temporary-reporting',
              path: 'clinic/temporary-reporting',
              component: () =>
                import('src/pages/clinic/TemporaryReporting.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'clinic/booking-source-reporting',
              path: 'clinic/booking-source-reporting',
              component: () => import('src/pages/clinic/BookingSources.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'clinic/schedule/staff',
              path: 'clinic/schedule/staff',
              component: () => import('src/pages/clinic/StaffSchedule.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'clinic/schedule/room',
              path: 'clinic/schedule/room',
              component: () => import('src/pages/clinic/RoomSchedule.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'clinic-schedule',
              path: 'clinic/:action/:type/:id/:year/:month/:day',
              component: () => import('src/pages/clinic/ScheduleView.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'your-schedule-view',
              path: 'clinic/:action/:type/:id/:year/:month/:day',
              component: () => import('src/pages/clinic/YourScheduleView.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'your-availability-view',
              path: 'clinic/:action/:type/:id/:year/:month/:day',
              component: () =>
                import('src/pages/clinic/YourAvailabilityView.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'clinic/availability',
              path: 'clinic/availability',
              component: () => import('src/pages/clinic/StaffAvailability.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'appointment-planner',
              path: 'clinic/appointment-planner',
              component: () =>
                import(
                  'pages/clinic/appointment-planner/AppointmentPlanner.vue'
                ),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/groups',
              path: 'admin/groups',
              component: () => import('pages/admin/group/GroupPage.vue'),
              meta: { requiresAuth: true },
            },
            {
              path: 'admin/release-notes',
              name: 'admin/release-notes',
              component: () => import('pages/release-notes/ReleaseNotes.vue'),
              meta: { requiresAuth: true },
            },
            {
              path: 'admin/duplicate-users',
              name: 'admin/duplicate-users',
              component: () =>
                import(
                  'pages/admin/duplicate-patient/DuplicatePatientPage.vue'
                ),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/users',
              path: 'admin/users',
              component: () => import('pages/admin/user/UserPage.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/staff',
              path: 'admin/staff',
              component: () => import('pages/admin/staff/StaffPage.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/sites',
              path: 'admin/sites',
              component: () => import('pages/admin/site/SitePage.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/rooms',
              path: 'admin/rooms',
              component: () => import('pages/admin/room/RoomPage.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/equipment',
              path: 'admin/equipment',
              component: () =>
                import('pages/admin/equipment/EquipmentPage.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/surgeries',
              path: 'admin/surgeries',
              component: () => import('pages/admin/surgery/GPSurgeryPage.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/competencies',
              path: 'admin/competencies',
              component: () =>
                import('pages/admin/competency/CompetencyPage.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/staff-competencies',
              path: 'admin/staff-competencies',
              component: () =>
                import('pages/admin/staff-competency/StaffCompetencyPage.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/staff-settings',
              path: 'admin/staff-settings',
              component: () =>
                import('pages/admin/staff-settings/StaffSettingsPage.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/eforms',
              path: 'admin/eforms',
              component: () => import('pages/admin/eForm/EFormPage.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/appointments',
              path: 'admin/appointments',
              component: () =>
                import('pages/admin/appointment/AppointmentPage.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/cancelled-appointments',
              path: 'admin/cancelled-appointments',
              component: () =>
                import('pages/admin/appointment/CancelledAppointmentPage.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/appointment-types',
              path: 'admin/appointment-types',
              component: () =>
                import('pages/admin/appointment-type/AppointmentTypePage.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/appointment-type-tags',
              path: 'admin/appointment-type-tags',
              component: () =>
                import(
                  'pages/admin/appointment-type-tag/AppointmentTypeTagPage.vue'
                ),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/appointment-categories',
              path: 'admin/appointment-categories',
              component: () =>
                import(
                  'pages/admin/appointment-category/AppointmentCategoryPage.vue'
                ),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/appointment-outcomes',
              path: 'admin/appointment-outcomes',
              component: () =>
                import(
                  'pages/admin/appointment-outcome/AppointmentOutcomePage.vue'
                ),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/vaccine-product',
              path: 'admin/vaccine-product',
              component: () =>
                import('pages/admin/vaccinate-product/VaccineProductPage.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/advice-category',
              path: 'admin/advice-category',
              component: () =>
                import('pages/admin/advice-category/AdviceCategoryPage.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/field-identifiers',
              path: 'admin/field-identifiers',
              component: () =>
                import('pages/admin/field-identifier/FieldIdentifierPage.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/allergies',
              path: 'admin/allergies',
              component: () => import('pages/admin/allergy/AllergyPage.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/incident-reports',
              path: 'admin/incident-reports',
              component: () =>
                import('pages/admin/incident-report/IncidentReportPage.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/safety-report-monthly',
              path: 'admin/safety-report-monthly/:year/:month',
              component: () =>
                import(
                  'pages/admin/incident-report/SafetyReportDetailPage.vue'
                ),
              meta: { requiresAuth: true, reportType: 'monthly' },
            },
            {
              name: 'admin/safety-report-annual',
              path: 'admin/safety-report-annual/:year',
              component: () =>
                import(
                  'pages/admin/incident-report/SafetyReportDetailPage.vue'
                ),
              meta: { requiresAuth: true, reportType: 'annual' },
            },
            {
              name: 'dashboard',
              path: 'dashboard',
              component: () => import('src/pages/dashboard/DashboardPage.vue'),
              meta: { requiresAuth: true },
            },
            {
              name: 'admin/configuration',
              path: 'admin/configuration',
              component: () =>
                import('pages/admin/settings-hub/AdminConfigurationPage.vue'),
              meta: { requiresAuth: true },
            },
            {
              path: '/admin/news-feed',
              name: '/admin/news-feed',
              component: { render: () => null },
              beforeEnter() {
                if (typeof window !== 'undefined') {
                  const $store = useEnvsStore();

                  window.location.href = `${$store.WAGTAIL_API_BASE}oidc/authenticate/?next=/api/cms/admin/`;
                }
              },
            },
          ],
        },
      ],
    },

    {
      path: '/callback',
      component: () => import('src/components/LoginCallback.vue'),
    },

    {
      path: '/logout-success',
      component: () => import('src/components/LogoutCallback.vue'),
      meta: { requiresAuth: true },
    },

    {
      path: '/silent-renew',
      component: () => import('src/components/SilentRenewCallback.vue'),
    },

    {
      path: '/healthz',
      component: () => import('src/components/HealthzPage.vue'),
    },

    // Always leave this as last one,
    // but you can also remove it
    {
      path: '/:catchAll(.*)*',
      component: () => import('pages/ErrorNotFound.vue'),
    },
  ];
  return routes;
}
